import { RetailUnitSchema, LotterySchema } from '@lotta/shared/types-lottery-schemas';
import type { Static } from '@sinclair/typebox';
import { Type } from '@sinclair/typebox';

export type DeleteLotteryParams = Static<typeof DeleteLotteryParamsSchema>;
export const DeleteLotteryParamsSchema = Type.Object(
  {
    retailUnit: RetailUnitSchema.properties.id,
    lotteryId: LotterySchema.properties.id,
  },
  { additionalProperties: false, $id: 'DeleteLotteryParamsSchema' }
);
